import React from "react";
import Input from "./BaseInput";
import { Form } from "antd";
import ShopDTO from "@/dto/shop/ShopDTO";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import ShopType from "@/enum/ShopType";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface BuyerUsernameFieldProps {
    shop?: ShopDTO;
}

const ignoreShopTypes = [
    ...SupplierShopTypes,
    ShopType.DOUDIAN_DROP_SHIPPING_SUPPLIER,
    ShopType.ALI_C2M,
    ShopType.SUNING,
    ShopType.PDD_FULFILLMENT,
];

const BuyerUsernameField: React.FC<BuyerUsernameFieldProps> = ({ shop }) => {
    if (ignoreShopTypes.includes(shop?.type)) return null;

    const label = [
        ShopType.PDD_FDS,
        ShopType.ALIBABA_SUPPLIER,
        ShopType.DOUDIAN_IOP,
        ShopType.KWAI_DROPSHIP,
        ShopType.CHANNEL_SHOP_DROPSHIP,
        ShopType.CHANNEL_SHOP_SUPPLIER,
    ].includes(shop?.type)
        ? "代理商昵称"
        : "买家昵称";

    return (
        <AutoDismissToolTip
            title={
                <p>
                    1、最多可同时搜索10个
                    <br />
                    2、多个通过中英文,号分隔
                </p>
            }
            trigger="click"
        >
            <Form.Item label={<span className="search-field-label">{label}</span>} name="buyerUsername">
                <Input allowClear />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(BuyerUsernameField);
